const languages = [
  { name: 'countries.fr', locale: 'fr' },
  { name: 'countries.pt', locale: 'pt' },
  /*  { name: 'countries.en', locale: 'en' },
   { name: 'countries.es', locale: 'es' }, */
]

export default languages
